import {
	CLEAR_FILES_SINGLE_ERROR,
	CLEAR_ALL_FILES_ERRORS,
	SET_FILE_ID,
	FILE_SAVE_LOADING,
	FILE_SAVE_ERROR,
	ALL_FILES_LOADING,
	ALL_FILES_GET,
	ALL_FILES_ERROR,
	FILE_INFO_LOADING,
	FILE_INFO_GET,
	FILE_INFO_ERROR,
	FILE_DELETE_LOADING,
	DOWNLOAD_FILE_LOADING,
	FILE_LOGS_LOADING,
	FILE_LOGS_GET,
	FILE_LOGS_ERROR
} from '../actions/types';

const initialState = {
	file_save_loading: false,
	file_id: null,
	all_files_loading: false,
	all_files: { count: 0, files: [] },
	file_info_loading: false,
	file_info: {},
	file_delete_loading: false,
	file_download_loading: false,
	file_logs_loading: false,
	file_logs: { count: 0, logs: [] },
	files_errors: {}
}

export default function fileReducer (state = initialState, action) {
	switch (action.type) {
		case CLEAR_ALL_FILES_ERRORS:
			return {
				...state,
				files_errors: {}
			}
		case CLEAR_FILES_SINGLE_ERROR:
			return {
				...state,
				files_errors: Object.keys(state.files_errors).reduce((acc, key) => {
					if (key !== action.payload) {
						acc[key] = state.files_errors[key];
					}
					return acc;
				}, {})
			}
		case SET_FILE_ID:
			return {
				...state,
				file_id: action.payload
			}
		case FILE_SAVE_LOADING:
			return {
				...state,
				file_save_loading: action.payload
			}
		case ALL_FILES_LOADING:
			return {
				...state,
				all_files_loading: action.payload
			}
		case ALL_FILES_GET:
			return {
				...state,
				all_files: {
					count: action.payload.count,
					files: action.payload.files
				}
			}
		case FILE_INFO_LOADING:
			return {
				...state,
				file_info_loading: action.payload
			}
		case FILE_INFO_GET:
			return {
				...state,
				file_info: action.payload
			}
		case FILE_DELETE_LOADING:
			return {
				...state,
				file_delete_loading: action.payload
			}
		case DOWNLOAD_FILE_LOADING:
			return {
				...state,
				file_download_loading: {
					...state.file_download_loading,
					[action.payload.fileId]: action.payload.loading
				}
			}
		case FILE_LOGS_LOADING:
			return {
				...state,
				file_logs_loading: action.payload
			}
		case FILE_LOGS_GET:
			return {
				...state,
				file_logs: {
					count: action.payload.count,
					logs: action.payload.logs
				}
			}
		case FILE_SAVE_ERROR:
		case ALL_FILES_ERROR:
		case FILE_INFO_ERROR:
		case FILE_LOGS_ERROR:
			return {
				...state,
				files_errors: {
					...state.files_errors, 
					[`${action.payload.type}`]: { msg: action.payload.msg }
				}
			}
		default:
			return state;
	}
}
